import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../utils/request';
import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const FilterBySalesManager = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterBySalesManager }
  } = localizedStrings;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await request.get('/salesManagers');
      if (result) {
        const transformedResult = _.get(result, 'data', []).map(
          salesManager => ({
            label: salesManager.name,
            value: salesManager.email
          })
        );
        setOptions(transformedResult);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, salesManager: value });
        }}
        label={filterBySalesManager}
        options={options}
        value={filters.salesManager}
      />
    </div>
  );
};

FilterBySalesManager.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterBySalesManager;
